import { css } from 'styled-components';

export interface FontFaceSpec {
    family: string;
    weights: Array<{
        weight: number;
        woff: string;
        woff2: string;
    }>;
}

/**
 * A font's URL. A bundler hands back the file's final URL, root-relative ("/assets/…",
 * "/_next/static/…") or absolute, and that is used as it is. Only a path relative to this module
 * (the library's own build, run without a bundler) is resolved against it: resolving a
 * root-relative one too made it a file: URL wherever the module is a file, as on a server
 * rendering the page, which a browser can't load.
 */
const resolveAssetUrl = (assetPath: string) => {
    if (!assetPath.startsWith('./') && !assetPath.startsWith('../')) return assetPath;
    try {
        return new URL(assetPath, import.meta.url).href;
    } catch {
        return assetPath;
    }
};

export function createFontFace({ family, weights }: FontFaceSpec) {
    return css`
        ${weights.map(({ weight, woff, woff2 }) => {
            const woffUrl = resolveAssetUrl(woff);
            const woff2Url = resolveAssetUrl(woff2);
            return css`
                @font-face {
                    font-family: '${family}';
                    font-style: normal;
                    font-weight: ${weight};
                    font-display: swap;
                    src:
                        local('${family}'),
                        url(${woff2Url}) format('woff2'),
                        url(${woffUrl}) format('woff');
                }
            `;
        })}
    `;
}
